module.exports = __webpack_public_path__ + "img/square_rotation_bf.2be77c98.svg";